import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import TracksManager from '../../manager/track/TracksManager';
import DialogActions from '@mui/material/DialogActions';
import { Button, Dialog, LinearProgress } from '@mui/material';
import React, { useContext, useState } from 'react';
import AppContext, { OBJECT_TYPE_FAVORITE, FAVORITES_URL_PARAM_FOLDER } from '../../context/AppContext';
import FavoritesManager, { findSelectedWpt } from '../../manager/FavoritesManager';
import FavoriteHelper from '../../infoblock/components/favorite/FavoriteHelper';
import PointManager from '../../manager/PointManager';
import isEmpty from 'lodash-es/isEmpty';
import { MENU_INFO_CLOSE_SIZE, FAVORITES_URL, MAIN_URL_WITH_SLASH } from '../../manager/GlobalManager';
import { useLocation, useNavigate } from 'react-router-dom';
import { isFavoriteFromSearch, navigateBackToSearchResults } from '../../manager/SearchManager';

export default function DeleteWptDialog({ dialogOpen, setDialogOpen, wpt = null, setOpenActions = null }) {
    const ctx = useContext(AppContext);
    const navigate = useNavigate();
    const location = useLocation();

    const useSelected = !isEmpty(ctx.selectedGpxFile) && ctx.selectedGpxFile.markerCurrent;
    const [process, setProcess] = useState(false);

    const toggleShowDialog = () => {
        setDialogOpen(!dialogOpen);
    };

    async function deleteWpt() {
        setProcess(true);
        //delete wpt from track
        if (ctx.addFavorite.editTrack || wpt?.trackWpt) {
            if (ctx.selectedWpt) {
                const lat = ctx.selectedWpt.latlng ? ctx.selectedWpt.latlng.lat : ctx.selectedWpt.lat;
                const lng = ctx.selectedWpt.latlng ? ctx.selectedWpt.latlng.lng : ctx.selectedWpt.lon;
                const ind = ctx.selectedGpxFile.wpts.findIndex((wpt) => wpt.lat === lat && wpt.lon === lng);
                PointManager.deleteWpt(ind, ctx, wpt.mapObj);
                ctx.setSelectedWpt(null);
                ctx.setSelectedFavoriteObj(null);
                if (wpt.mapObj) {
                    ctx.setCreateTrack({ ...ctx.createTrack, cloudAutoSave: true });
                }
                closeDialog();
            }
        } else {
            //delete favorite point from group
            const favGroup = useSelected ? ctx.selectedGpxFile.nameGroup : wpt.category;
            const deletedFromSearch = isDeletedFavoriteFromSearch();
            ctx.setProcessingGroups(true);
            if (deletedFromSearch) {
                navigateBackToSearchResults(navigate, ctx, location);
            } else if (favGroup) {
                const savedParams = ctx.pageParams?.[OBJECT_TYPE_FAVORITE];
                if (savedParams?.includes(FAVORITES_URL_PARAM_FOLDER)) {
                    navigate(MAIN_URL_WITH_SLASH + FAVORITES_URL + savedParams + globalThis.location.hash, {
                        replace: true,
                    });
                } else {
                    console.debug('No folder param saved, navigating to favorites main url');
                    navigate(MAIN_URL_WITH_SLASH + FAVORITES_URL + globalThis.location.hash, { replace: true });
                }
            } else {
                navigate(MAIN_URL_WITH_SLASH + FAVORITES_URL + globalThis.location.hash, { replace: true });
            }

            deleteFavorite().then(() => {
                setTimeout(() => {
                    if (deletedFromSearch) {
                        ctx.setSelectedSearchObj(null);
                    }
                    ctx.setSelectedWpt(null);
                    ctx.setSelectedWptId(null);
                    ctx.setSelectedFavoriteObj(null);
                    ctx.setSelectedGpxFile({});
                    ctx.setCurrentObjectType(null);
                    if (wpt.mapObj) {
                        ctx.setInfoBlockWidth(`${MENU_INFO_CLOSE_SIZE}px`);
                    }
                    closeDialog();
                }, 0);
            });
        }
    }

    // the favorite opened from search results is the one being deleted
    function isDeletedFavoriteFromSearch() {
        const opened = ctx.selectedSearchObj?.object?.markerCurrent;
        const name = useSelected ? ctx.selectedGpxFile.markerCurrent.name : wpt.name;
        const groupId = useSelected ? ctx.selectedGpxFile.id : wpt.groupId;
        return isFavoriteFromSearch(ctx) && opened?.name === name && opened?.groupId === groupId;
    }

    function closeDialog() {
        setProcess(false);
        setDialogOpen(false);
        if (setOpenActions) {
            setOpenActions(false);
        }
    }

    async function deleteFavorite() {
        const arrWpt = useSelected ? ctx.selectedGpxFile.trackData.wpts : ctx.favorites.mapObjs[wpt.groupId].wpts;
        const groupName = useSelected ? ctx.selectedGpxFile.nameGroup : wpt.category;
        const id = useSelected ? ctx.selectedGpxFile.id : wpt.groupId;
        const groupFullName = useSelected ? ctx.selectedGpxFile.file.name : wpt.group.file.name;
        const selectedGroup = ctx.favorites.groups.find((g) => g.id === id);
        const currentWpt = findSelectedWpt(useSelected ? ctx.selectedGpxFile.markerCurrent : wpt, arrWpt);
        if (!currentWpt) {
            return;
        }
        const result = await FavoritesManager.deleteFavorite(
            currentWpt,
            groupFullName,
            selectedGroup.file.updatetimems,
            arrWpt.indexOf(currentWpt)
        );
        //update favorites groups
        if (result) {
            ctx.favorites.mapObjs[id] = FavoriteHelper.updateGroupObj(ctx.favorites.mapObjs[id], result);
            const updatedFavorites = FavoriteHelper.updateSelectedGroup({
                favorites: ctx.favorites,
                selectedGroupName: groupName,
                result,
                id,
            });
            useSelected &&
                FavoriteHelper.updateSelectedFile({
                    ctx,
                    result,
                    favoriteName: ctx.selectedGpxFile.markerCurrent.name,
                    selectedGroup,
                    deleted: true,
                });
            ctx.setFavorites(updatedFavorites);
            ctx.setUpdateMarkers({ ...updatedFavorites });
            closeContextMenu();
        }
    }

    function closeContextMenu() {
        setDialogOpen(false);
        ctx.setCurrentObjectType(null);
    }

    function getTitleDialog() {
        return ctx.addFavorite.editTrack ? 'Delete waypoint' : 'Delete favorite';
    }

    function getQuestionDialog() {
        return ctx.addFavorite.editTrack
            ? `Are you sure you want to delete ${wpt.name}?`
            : `Are you sure you want to delete ${TracksManager.prepareName(
                  useSelected ? ctx.selectedGpxFile.markerCurrent.name : wpt.name
              )}?`;
    }

    return (
        <Dialog id="se-delete-fav-dialog" open={true} onClose={toggleShowDialog} onClick={(e) => e.stopPropagation()}>
            {process ? <LinearProgress /> : <></>}
            <DialogTitle>{getTitleDialog()}</DialogTitle>
            <DialogContent>
                <DialogContentText>{getQuestionDialog()}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button id="se-delete-fav-dialog-submit" onClick={deleteWpt}>
                    Delete
                </Button>
                <Button onClick={toggleShowDialog}>Cancel</Button>
            </DialogActions>
        </Dialog>
    );
}
